import { render, staticRenderFns } from "./Test23.vue?vue&type=template&id=2204d308&"
import script from "./Test23.vue?vue&type=script&lang=js&"
export * from "./Test23.vue?vue&type=script&lang=js&"
import style0 from "./Test23.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports